import { FC, useContext } from 'react';
import { Box } from '@chakra-ui/react';
import BookingForm from '../../Node/Hotel/Forms/BookingForm';
import InfolinoContext from '../../../context/InfolinoContext';

type InfolinoContactProps = {};

const InfolinoContact: FC<InfolinoContactProps> = () => {
  const infolinoContext = useContext(InfolinoContext);

  return (
    <Box>
      <BookingForm
        hotelId={infolinoContext.hotel?.id}
        isOpen={true}
        onClose={() => null}
        inline
      />
    </Box>
  );
};

export default InfolinoContact;
